import {AccountData, SNSData, SNSDataList} from "../../util/api";

const twitterURL = "https://twitter.com/";
const youtubeURL = "https://www.youtube.com/";

const demoAccounts: AccountData[] = [
    {
        id: 1,
        serviceType: "youtube",
        name: "佐藤太郎 / Taro Sato",
        imageUrl:
            "https://cdn.pixabay.com/photo/2020/04/25/23/47/father-5093047_960_720.jpg",
    },
    {
        id: 2,
        serviceType: "twitter",
        name: "さちこ",
        imageUrl:
            "https://cdn.pixabay.com/photo/2020/04/24/18/02/girl-5087960_960_720.jpg",
    },
    {
        id: 3,
        serviceType: "twitter",
        name: "けん",
        imageUrl:
            "https://cdn.pixabay.com/photo/2015/02/13/22/10/runners-635906_960_720.jpg",
    },
    {
        id: 4,
        serviceType: "youtube",
        name: "幸福チャンネル",
        imageUrl:
            "https://cdn.pixabay.com/photo/2020/04/25/20/33/mountain-5092625_960_720.jpg",
    },
    {
        id: 5,
        serviceType: "youtube",
        name: "健太ゲームチャンネル",
        imageUrl:
            "https://cdn.pixabay.com/photo/2013/10/02/23/03/dawn-190055_960_720.jpg",
    },
    {
        id: 6,
        serviceType: "youtube",
        name: "Sato Game Channel",
        imageUrl:
            "https://cdn.pixabay.com/photo/2016/08/09/21/54/yellowstone-national-park-1581879_960_720.jpg",
    },
    {
        id: 7,
        serviceType: "twitter",
        name: "松田かおり",
        imageUrl:
            "https://cdn.pixabay.com/photo/2016/09/13/09/25/kite-1666816_960_720.jpg",
    },
];

const youtubeData = [
    {
        type: "youtube",
        originalUrl: youtubeURL,
        pictureUrl:
            "https://cdn.pixabay.com/photo/2020/08/12/09/21/sunflowers-5482116_960_720.jpg",
        title: "世界一のひまわり畑に行ってみた",
        content: "世界一のひまわり畑に行ってみた",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[0].name,
        ownerIcon: demoAccounts[0].imageUrl,
        ownerPage: youtubeURL,
    },
    {
        type: "youtube",
        originalUrl: youtubeURL,
        pictureUrl:
            "https://cdn.pixabay.com/photo/2020/08/14/12/34/saltburn-pier-5487835_960_720.jpg",
        title: "私のモーニングルーティン",
        content: "私のモーニングルーティン",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[1].name,
        ownerIcon: demoAccounts[1].imageUrl,
        ownerPage: youtubeURL,
    },
    {
        type: "youtube",
        originalUrl: youtubeURL,
        pictureUrl:
            "https://cdn.pixabay.com/photo/2020/05/19/20/01/integration-5192458_960_720.jpg",
        title: "今日あった最高の話",
        content: "今日あった最高の話",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[1].name,
        ownerIcon: demoAccounts[1].imageUrl,
        ownerPage: youtubeURL,
    },
    {
        type: "youtube",
        originalUrl: youtubeURL,
        pictureUrl:
            "https://cdn.pixabay.com/photo/2015/01/08/18/27/startup-593341_960_720.jpg",
        title: "明日幸せになるためには",
        content: "明日幸せになるためには",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[3].name,
        ownerIcon: demoAccounts[3].imageUrl,
        ownerPage: youtubeURL,
    },
    {
        type: "youtube",
        originalUrl: youtubeURL,
        pictureUrl:
            "https://cdn.pixabay.com/photo/2015/01/08/18/24/children-593313_960_720.jpg",
        title: "有名配信者と同じパーティに！",
        content: "有名配信者と同じパーティに！",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[4].name,
        ownerIcon: demoAccounts[4].imageUrl,
        ownerPage: youtubeURL,
    },
    {
        type: "youtube",
        originalUrl: youtubeURL,
        pictureUrl:
            "https://cdn.pixabay.com/photo/2016/11/21/15/08/computer-1845880_960_720.jpg",
        title: "最新人気ゲームの裏技紹介！",
        content: "最新人気ゲームの裏技紹介！",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[5].name,
        ownerIcon: demoAccounts[5].imageUrl,
        ownerPage: youtubeURL,
    },
    {
        type: "youtube",
        originalUrl: youtubeURL,
        pictureUrl:
            "https://cdn.pixabay.com/photo/2017/12/17/12/45/football-3024154_960_720.jpg",
        title: "あのゲームプレイ中に奇跡が...",
        content: "あのゲームプレイ中に奇跡が...",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[4].name,
        ownerIcon: demoAccounts[4].imageUrl,
        ownerPage: youtubeURL,
    },
];

const twitterData = [
    {
        type: "twitter",
        originalUrl: twitterURL,
        content: "明日は大事な日。今日は早く寝る",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[2].name,
        ownerIcon: demoAccounts[2].imageUrl,
        ownerPage: twitterURL,
        meta: {
            like: 99,
            comment: 2,
            retweet: 5,
        },
    },
    {
        type: "twitter",
        originalUrl: twitterURL,
        content: "頭痛い",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[6].name,
        ownerIcon: demoAccounts[6].imageUrl,
        ownerPage: twitterURL,
        meta: {
            like: 7,
            comment: 150,
            retweet: 2,
        },
    },
    {
        type: "twitter",
        originalUrl: twitterURL,
        content: "今日めっちゃ調子良い",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[2].name,
        ownerIcon: demoAccounts[2].imageUrl,
        ownerPage: twitterURL,
        meta: {
            like: 957,
            comment: 100,
            retweet: 450,
        },
    },
    {
        type: "twitter",
        originalUrl: twitterURL,
        content: "明日も多分眠い",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[1].name,
        ownerIcon: demoAccounts[1].imageUrl,
        ownerPage: twitterURL,
        meta: {
            like: 10,
            comment: 0,
            retweet: 5000,
        },
    },
    {
        type: "twitter",
        originalUrl: twitterURL,
        content: "今日は今日とて眠い",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[1].name,
        ownerIcon: demoAccounts[1].imageUrl,
        ownerPage: twitterURL,
        meta: {
            like: 12,
            comment: 0,
            retweet: 2,
        },
    },
    {
        type: "twitter",
        originalUrl: twitterURL,
        content: "ファスティング2日目。もう効果出てきた。",
        createdAt: new Date("2020/08/28"),
        owner: demoAccounts[2].name,
        ownerIcon: demoAccounts[2].imageUrl,
        ownerPage: twitterURL,
        meta: {
            like: 734,
            comment: 9091,
            retweet: 0,
        },
    },
];

const contentsA: SNSData[] = [
    youtubeData[0],
    twitterData[0],
    youtubeData[1],
    twitterData[2],
];

const listA: SNSDataList = {
    id: 1,
    name: "お気に入り",
    snsData: contentsA,
    accounts: demoAccounts,
};

const contentsB: SNSData[] = [
    twitterData[0],
    youtubeData[2],
    youtubeData[3],
    twitterData[2],
];

const listB: SNSDataList = {
    id: 2,
    name: "ビジネス",
    snsData: contentsB,
    accounts: [demoAccounts[1], demoAccounts[2], demoAccounts[3]],
};

const contentsC: SNSData[] = [youtubeData[4], youtubeData[5], youtubeData[6]];

const listC: SNSDataList = {
    id: 3,
    name: "ゲーム",
    snsData: contentsC,
    accounts: [demoAccounts[4], demoAccounts[5]],
};

const contentsD: SNSData[] = twitterData;

const listD: SNSDataList = {
    id: 4,
    name: "友達",
    snsData: contentsD,
    accounts: [demoAccounts[1], demoAccounts[2], demoAccounts[6]],
};

export const DemoListData: SNSDataList[] = [listA, listB, listC, listD];
